const INIT_STATE = {
   translations: []
};
export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_TRANSLATIONS": {
         return {
            ...state,
            translations: action.payload
         };
      }
      default:
         return state;
   }
};
